<template>
  <el-form v-if="isInit">
    <table class="edit-form-table">
      <tr class="_tr" v-for="(tr, trI) in handleFormOptions" :key="trI">
        <template v-for="(td, tdI) in tr">
          <td :key="tdI"><span :class="{'isRequired': td.required}" v-show="!td.hidden">{{td.title}}</span></td>
          <td :key="tdI + 100000">
            <edit-item class="form-item-box"
              v-show="!td.hidden"
              v-if="td.type"
              ref="editItems"
              :editable="editable"
              :item="td">
              <template :slot="`${prop}`" slot-scope="scope" v-for="prop in Object.keys($scopedSlots)">
                <slot :name="`${prop}`" v-bind="scope"></slot>
              </template>
            </edit-item>
          </td>
        </template>
      </tr>
    </table>
  </el-form>
</template>

<script>
import { preArrayMultiple } from '../../../utils'
import formValidate from './formValidate.mixin'
export default {
  name: 'EditFormTable',
  mixins: [formValidate], // // 表单插槽以及表单校验相关的代码
  data () {
    return {
      handleFormOptions: []
    }
  },
  props: {
    editable: Boolean,
    config: {
      type: Object,
      default: () => {
        return {
          column: 3 // 默认一行放3列（label+value）
        }
      }
    },
    formOptions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  created () {
    this.resetData()
  },
  mounted () {
  },
  watch: {
    formOptions (n) {
      this.resetData(n)
    }
  },
  methods: {
    resetData () {
      this.handleFormOptions = preArrayMultiple(this.formOptions, this.config.column, {})
    }
  }
}
</script>
